import { TextField } from "@mui/material";
import React from "react";
import { Form } from "../../interfaces/forms";
import { Controller, useFormContext } from "react-hook-form";

interface NumberFormProps {
  field: Form;
}
function NumberForm(props: NumberFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={props.field.name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          sx={{ width: "100%" }}
          label={props.field.label}
          error={!!errors[props.field.name]}
          InputProps={{ inputProps: { min: 0 } }}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
          helperText={
            errors[props.field.name]
              ? (errors[props.field.name]?.message as string)
              : ""
          }
        />
      )}
    />
  );
}

export default NumberForm;
